<template>
  <div>
    <v-container class="pa-0 ma-0 fluid" fill-height>
      <v-layout column>
        <v-card v-if="isAdmin" dark color="light-blue darken-3" class="tri-bg">
              <v-container class="pt-1 pb-0 px-4 fluid" color="primary">
              <v-layout row wrap justify-space-between>
              <v-flex class="d-inline-block runner-chooser">
                  <span class="headline mr-4">TRENER:</span>
                  <span class="d-inline-block">
                    <v-btn flat class="upper" small icon v-tooltip="'poprzedni'" @click="prevTrainer">
                      <v-icon>
                        keyboard_arrow_left
                      </v-icon>
                    </v-btn>
                    <span class="title">{{ trainer.first_name }} {{ trainer.last_name }}</span>
                    <v-btn flat class='upper' small icon v-tooltip="'następny'" @click="nextTrainer">
                      <v-icon>
                        keyboard_arrow_right
                      </v-icon>
                    </v-btn>
                  </span>
              </v-flex>
              <v-flex class="d-inline-block runner-mini-menu">
                <v-tabs fixed-tabs dark color="transparent">
                  <v-tab :to="{name: 'trainer-data', params: {id: $route.params.id}}">
                    Dane
                  </v-tab>
                  <v-tab :to="{name: 'trainer-runners', params: {id: $route.params.id}}">
                    Zawodnicy
                  </v-tab>
                  <v-tab :to="{name: 'trainer-videos', params: {id: $route.params.id}}">
                    Filmy
                  </v-tab>
                </v-tabs>
              </v-flex>
              </v-layout>
              </v-container>
        </v-card>
      </v-layout>
    </v-container>
    <v-container fill-height>
      <v-layout>
        <v-flex>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as types from '@/store/mutation-types'
import store from '@/store'

export default {
  computed: {
    ...mapGetters(['isAdmin']),
    ...mapState(['trainer', 'adminTrainers'])
  },
  created () {
    if (this.isAdmin) {
      this.$store.dispatch(types.ADMIN_TRAINERS_REQUEST)
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch(types.TRAINER_REQUEST, to.params.id).then(() => {
      next()
    })
  },
  beforeRouteUpdate (to, from, next) {
    store.dispatch(types.TRAINER_REQUEST, to.params.id).then(() => {
      next()
    })
  },
  methods: {
    nextTrainer () {
      let trainers = this.adminTrainers
      let newIndex
      let index = trainers.findIndex((elem) => {
        return this.trainer.id === elem.id
      })
      if (index < 0) {
        return
      }
      if (index === trainers.length - 1) {
        newIndex = 0
      } else {
        newIndex = index + 1
      }
      this.$router.push({name: this.$route.name, params: {id: trainers[newIndex].id}})
    },
    prevTrainer () {
      let trainers = this.adminTrainers
      let newIndex
      let index = trainers.findIndex((elem) => {
        return this.trainer.id === elem.id
      })
      if (index < 0) {
        return
      }
      if (index === 0) {
        newIndex = trainers.length - 1
      } else {
        newIndex = index - 1
      }
      this.$router.push({name: this.$route.name, params: {id: trainers[newIndex].id}})
    }
  }
}
</script>
<style>

  .tri-bg {
      background-image: url('../assets/img/trianglify-max.jpg');
      background-repeat: repeat;
  }
</style>



// WEBPACK FOOTER //
// src/layouts/TrainerPanelLayout.vue